import invoiceInstance from '../instance'

const getInvoiceConfigs = () => {
	return invoiceInstance.get('/invoiceConfigs')
}

export default getInvoiceConfigs
